import { isArray } from '@dimjs/lang';
import {
  getRunningEnv,
  sessionStorageCache,
  type TPlainObject,
} from '@flatbiz/utils';

const iframeOpenNewTabItemOperateLinkKey =
  'iframe-open-new-tab-item-operate-link';

/**
 * 保存操作 OpenNewTabItem 链路
 */
export const saveIframeOpenNewTabItemOperateLink = (params: {
  startTabId: string;
  startTabMenuId?: string;
  endTabId: string;
}) => {
  const operateLinkData = sessionStorageCache.get(
    iframeOpenNewTabItemOperateLinkKey
  );
  const dataList = (
    isArray(operateLinkData?.dataList) ? operateLinkData?.dataList : []
  ) as TPlainObject[];
  dataList.push(params);
  sessionStorageCache.set(iframeOpenNewTabItemOperateLinkKey, {
    dataList: dataList,
  });
};

/**
 * 删除操作 OpenNewTabItem 链路
 * @param startTabId 目标 tabId
 * @param isReverse 是否反向删除
 * @returns
 */
export const removeIframeOpenNewTabItemOperateLink = (
  startTabId: string,
  isReverse: boolean = false
) => {
  const operateLinkData = sessionStorageCache.get(
    iframeOpenNewTabItemOperateLinkKey
  );
  const dataList = (
    isArray(operateLinkData?.dataList) ? operateLinkData?.dataList : []
  ) as TPlainObject[];
  let dataListNew: TPlainObject[];
  if (!isReverse) {
    dataListNew = dataList.filter((item) => item.startTabId != startTabId);
  } else {
    dataListNew = dataList.filter((item) => item.startTabId == startTabId);
  }
  sessionStorageCache.set(iframeOpenNewTabItemOperateLinkKey, {
    dataList: dataListNew,
  });
};

export const getIframeOpenNewTabItemOperateLinkList = () => {
  const operateLinkData = sessionStorageCache.get(
    iframeOpenNewTabItemOperateLinkKey
  );
  return (
    isArray(operateLinkData?.dataList) ? operateLinkData?.dataList : []
  ) as TPlainObject[];
};

export const getDefaultHeaderThemeConfig = () => {
  const env = getRunningEnv();
  const headerThemeConfig = {
    inte: {
      bgColor: '#38B990',
    },
    rc: {
      bgColor: '#e59d1a',
    },
    me: {
      bgColor: '#0c1e3e',
    },
  };
  return headerThemeConfig[env];
};
